import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
import Layout from "@/layout";
import store from "@/store";

export const asyncRoutes = [
  {
    path: "/innerReport",
    component: () => import("@/views/innerReport/index"),
    name: "innerReport",
    meta: {
      title: "内部检测报告",
      icon: "innerReport",
      roles: ["ADMIN", "INNER"],
    },
  },
  {
    path: "/publicReport",
    component: () => import("@/views/publicReport/index"),
    name: "publicReport",
    meta: {
      title: "公共检测报告库",
      icon: "publicReport",
      roles: ["ADMIN", "OUTER"],
    },
  },
  {
    path: "/user",
    component: () => import("@/views/user/index"),
    name: "user",
    meta: { title: "用户管理", icon: "user", roles: ["ADMIN"] },
  },
];

export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: { title: "登陆", icon: "login", roles: ["ADMIN", "INNER", "OUTER"] },
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    name: "Page404",
    meta: { title: "404", noCache: true },
  },
  {
    path: "/preview",
    component: () => import("@/views/preview"),
    name: "preview",
    meta: { title: "预览", noCache: true, roles: ["ADMIN", "OUTER"] },
  },
];

const home = store.state.user.home;

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      {
        path: "/",
        component: Layout,
        name: "layout",
        // redirect: (home && home.path) || "/login",
      },
      ...constantRoutes,
    ],
  });

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

const router = createRouter();

export default router;
